import { graphql } from 'react-relay';

export default graphql`
  query GroupFundraiserPage_Query {
    viewer {
      id
      ...GroupFundraiserPage_viewer
    }
  }
`;
